import {useMutation} from '@apollo/client/react';
import {Job, QuestionStatus} from '@cp/model';
import {CREATE_BULK_CHANGE_QUESTION_STATUS_JOB} from './sharedQueries';

export function useCreateBulkChangeQuestionStatusJob() {
  const [createBulkChangeQuestionStatusJobMutation, {loading, error}] = useMutation<
    {createBulkChangeQuestionStatusJob: Job},
    {moduleId: string; filterStatus: QuestionStatus; changeStatus: QuestionStatus}
  >(CREATE_BULK_CHANGE_QUESTION_STATUS_JOB);

  /**
   * Create a bulk change question status job
   * @param moduleId - The module ID to change question statuses for
   * @param filterStatus - The current status to filter questions by
   * @param changeStatus - The new status to change questions to
   * @returns Job if successful, otherwise undefined
   */
  const createBulkChangeQuestionStatusJob = async (
    moduleId: string,
    filterStatus: QuestionStatus,
    changeStatus: QuestionStatus,
  ) => {
    const result = await createBulkChangeQuestionStatusJobMutation({
      variables: {moduleId, filterStatus, changeStatus},
    });

    return result.data?.createBulkChangeQuestionStatusJob;
  };

  return {
    createBulkChangeQuestionStatusJob,
    loading,
    error,
  };
}
